import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex align-center text-caption text-medium-emphasis mt-2"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppealCoverSheetField',
    props: {
        items: {},
        templateId: { default: null },
        text: { default: "" },
        loading: { type: Boolean, default: false },
        filling: { type: Boolean, default: false }
    },
    emits: ["select", "update:text"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                                items: __props.items,
                                "model-value": __props.templateId,
                                label: "Cover sheet",
                                loading: __props.loading,
                                disabled: __props.filling,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('select', value))
                            }, null, 8, ["items", "model-value", "loading", "disabled"]),
                            (__props.filling)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createVNode(_component_v_progress_circular, {
                                        indeterminate: "",
                                        color: "primary",
                                        size: "16",
                                        width: "2",
                                        class: "mr-2"
                                    }),
                                    _cache[2] || (_cache[2] = _createTextVNode(" Filling the cover sheet from this submission… ", -1))
                                ]))
                                : (__props.templateId || __props.text)
                                    ? (_openBlock(), _createBlock(_component_v_textarea, {
                                        key: 1,
                                        "model-value": __props.text,
                                        label: "Cover sheet",
                                        rows: "8",
                                        "auto-grow": "",
                                        class: "mt-3",
                                        hint: "Fields with no value on file are left blank — complete them before sending.",
                                        "persistent-hint": "",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => emit('update:text', value))
                                    }, null, 8, ["model-value"]))
                                    : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
